<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      :visible.sync="modalVisible"
      size="full"
      :contentStyle="{'height': '100%', 'display': 'flex', 'flex-direction': 'column'}"
      :footer="false">
    <template #header>
      <span>选择入库单</span>
    </template>
    <template #content>
      <gj-area-title>基本信息</gj-area-title>
      <gj-desc-group
          :label-width="'90px'"
          style="margin-bottom: 10px;">
        <el-row>
<!--          <el-col :span="8">-->
<!--            <gj-desc-->
<!--                label="入库仓库">-->
<!--              自营仓001-->
<!--            </gj-desc>-->
<!--          </el-col>-->
          <el-col :span="8">
            <gj-desc
                label="SKU"
                :content="sku">
            </gj-desc>
          </el-col>
        </el-row>
      </gj-desc-group>
      <gj-area-title>单价明细</gj-area-title>
      <app-base-main
          :table-shadow="false"
          no-padding
          parentTable
          style="margin-top: 16px;">
        <template #filter-group>
          <app-filter-group
              @query="$gjNoticeQuery"
              @reset="$gjReset">
            <gj-date-picker
                v-model="filter.date"
                type="daterange"
                tooltip="创建时间"
            ></gj-date-picker>
            <gj-input
                v-model="filter.code"
                placeholder="入库单号"
                width="150px"
            ></gj-input>
          </app-filter-group>
        </template>
        <template #table>
          <gj-table
              ref="gjTable"
              :index="false"
              adaptParent
              border
              :loading="loading"
              :data="tableData"
              :columns="columns"
              :adapt-height-listen-update="false"
              :offset-height="0"
              :pagination="pagination"
              :structure-config="{type: 'ParentChild', children: 'voList', spanType: 'row', parentSpan: ['0-1', 8]}"
              @sort-change="$gjSortChange"
              @page-change="$gjNoticeQuery">
            <template v-slot:sku="{row}">
              <div>
                <gj-tooltip
                    :text-line="1"
                    :content="row.productName">
                  {{row.productName | defaultShow}}
                </gj-tooltip>
              </div>
              <div>{{row.sku | defaultShow}}</div>
            </template>
            <template v-slot:op="{row}">
              <gj-button
                  type="text"
                  @click="select(row)">
                选择
              </gj-button>
            </template>
          </gj-table>
        </template>
      </app-base-main>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin, selectionMixin} from "@/minxins";
  import {convertToDate} from "@/utils/date.util";
  import {defaultVal} from "@/utils/common";
  import {getCostSupplementInboundPage} from "@/api/warehouse";

  export default {
    name: "app-select-inbound-order-modal",
    mixins: [modalMixIn, queryMixin, selectionMixin],
    props: {
      warehouseId: {
        required: true,
      },
      sku: {
        required: true
      },
      costType: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'code', header: '入库单号', field: 'code', width: '150px'},
          {id: 'createTime', header: '创建时间', field: 'createTime', width: '120px'},
          {id: 'sku', header: '产品名称/SKU', field: 'slot:sku', minWidth: '200px'},
          {id: 'quantity', header: '入库量', field: 'quantity', width: '80px', align: 'right'},
          {id: 'purchaseCost', header: '采购成本', field: 'purchaseCost', prefix: 'currencySymbol', width: '90px', align: 'right'},
          {id: 'arriveCost', header: '到库成本', field: 'arriveCost', prefix: 'currencySymbol', width: '90px', align: 'right'},
          {id: 'totalPurchaseCost', header: '总采购成本', field: 'totalPurchaseCost', prefix: 'currencySymbol', width: '100px', align: 'right'},
          {id: 'totalArriveCost', header: '总到库成本', field: 'totalArriveCost', prefix: 'currencySymbol', width: '100px', align: 'right'},
          {id: 'op', header: '操作', field: 'slot:op', width: '60px'}
        ],
        filter: {},
      }
    },
    methods: {
      $gjQueryInitParams() {
        return {
          filter: {
            date: [],
            code: null
          },
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            warehouseId: this.warehouseId,
            sku: this.sku,
            startCreateTime: this.filter.date[0] ? convertToDate(this.filter.date[0]) : null,
            endCreateTime: this.filter.date[1] ? convertToDate(this.filter.date[1]) : null,
            code: defaultVal(this.filter.code),
            costType: this.costType,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading = true;
        getCostSupplementInboundPage(params)
          .then(data => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          })
          .complete(() => this.loading = false);
      },
      select(row) {
        const item = row.voList.find(item => item.sku === this.sku);
        this.$emit('select', {
          relevanceItemId: row.id,
          relevanceCode: row.code,
          purchaseCost: item.purchaseCost,
          arriveCost: item.arriveCost,
          quantity: item.quantity,
          currency: item.currency,
          currencySymbol: item.currencySymbol,
        });
        this.$gjDestroy();
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ .gj-area-title {
    margin-bottom: 10px;
  }
  /deep/ .base-main-margin{
    flex: 1;
    overflow: auto;
  }
  /deep/ .footer__pagination.border{
    border: none;
  }
</style>
